import { Card, Divider } from 'antd';
import React, { useEffect, useState } from 'react';
import Marquee from "react-fast-marquee";
import useApi from '../../hooks/useApi';
import { isEmpty } from '../../generalFunctions';
import { useNavigate } from 'react-router-dom';
import newImage from "../../assets/images/website/new-blinking-withoutbg.gif";

const ScrollingText = () => {
    const [response, request] = useApi("/website/home/moving-text");
    const [scrollingText, setScrollingText] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        request();
    }, []);//eslint-disable-line

    useEffect(() => {
        if (!isEmpty(response.data) && !response.error && !response.isLoading) {
            setScrollingText(response.data);
        }

    }, [response]);

    return (
        <Card bodyStyle={{ padding: 0 }} className='card-border'>
            <Marquee>
                {scrollingText?.map(element =>
                    <>
                        <h3 key={element.id} style={{ cursor: "pointer", display: "inline-flex", justifyContent: "center" }} onClick={() => navigate('/notice', { state: { notice: element } })}>
                            <img src={newImage} style={{ width: 60 }} />
                            {element.text}
                            <Divider type='vertical' style={{ marginLeft: 8, height: 30, backgroundColor: "#0bad5f" }} />
                        </h3>
                    </>
                )}
            </Marquee>
        </Card >
    );
}

export default ScrollingText;